import React from "react";
import clsx from "clsx";
import { Dialog, DialogContent } from "@mui/material";
import { Icons, Button, Box, Typography, Stack } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { Link } from "react-router-dom";
import { ACCOUNT_BOOK_ORDERS_ORDER_URL } from "@icoach/router/routerPath";

const CheckoutCompleteDialog = props => {
	const { className, open, sourceData = {}, onClose } = props;
	const { orderID } = sourceData || {};

	const handleClose = () => {
		if (onClose) {
			onClose();
		}
	};

	const handleContinueCheckout = () => {
		handleClose();
	};

	if (!open) return null;

	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-50rem" }} open={open} maxWidth="md" fullWidth>
			<GradientColorHeader onClose={handleClose}>提示</GradientColorHeader>
			<DialogContent>
				<Box className="text-center">
					{/* 成功圖示 */}
					<Box className="my-3">
						<Icons.CheckCircle className="text-primary" style={{ fontSize: "60px" }} />
					</Box>
					{/* 交易成功標題 */}
					<Typography className="font-weight-bold text-primary mb-4" variant="h3">
						結帳完成
					</Typography>

					<Typography className="font-weight-bold mb-1" variant="h6">
						已結帳完成，是否要繼續使用POS系統?
					</Typography>
					<Stack className="text-error text-primary mb-4 pb-2" justifyContent="center" direction="row" alignItems="center" spacing={1}>
						<Icons.ErrorOutline className="text-error" />
						<span>注意!!查看明細會直接離開POS系統</span>
					</Stack>

					{/* 操作按鈕 */}
					<Stack className={"mb-1"} justifyContent="center" alignItems="center" spacing={2}>
						<Button variant="outlined" onClick={handleContinueCheckout}>
							繼續結帳
						</Button>
						<Button variant="contained" component={Link} to={ACCOUNT_BOOK_ORDERS_ORDER_URL(orderID)}>
							查看明細
						</Button>
					</Stack>
				</Box>
			</DialogContent>
		</Dialog>
	);
};

export default CheckoutCompleteDialog;
